export default __webpack_public_path__ + "static/media/fMaltoBuza12.cf7dc164.png";